export default (num) => {
  return (num + "").padStart(2, "0")
}
